import { makeSupabaseClient } from '@/shared/infra/supabase'
import { SupabaseLoadAccessTokenRepository } from '@/modules/auth/infra'
import type { LoadAccessToken } from '@/modules/auth/use-cases'

export function makeLoadAccessToken(): LoadAccessToken {
  return new SupabaseLoadAccessTokenRepository(makeSupabaseClient()).execute
}
